module.exports = __webpack_public_path__ + "static/media/teltonika-fm1202-waterproof-gps-1.a36c0884.jpg";